import ThronVideo from '@components/utils/ThronVideo';
import analytics from '@utils/analytics';
import React, { useEffect } from 'react';
import SwiperCore, { A11y, Navigation } from 'swiper';
import { Swiper as SwiperInstance, SwiperSlide } from 'swiper/react';
import ProductTileFeatured from './ProductTileFeatured';
SwiperCore.use([Navigation, A11y]);
const FeaturedProducts = (props) => {
    const videoBg = props.featuredProductsCarousel.thronID || props.featuredProductsCarousel.thronMobileID;
    let carouselClasses = 'product-carousel featured-products-carousel';
    carouselClasses += props.featuredProductsCarousel.simplified ? ' simplified' : '';
    carouselClasses += props.featuredProductsCarousel.inverted ? ' inverted' : '';
    carouselClasses += videoBg ? ' video' : '';
    useEffect(() => {
        let products = [];
        props.featuredProductsCarousel.regions.product_slides.components.map((component, i) => (products[i] = component.product));
        analytics.productImpressionsRecommended(products, `featured products_${props.featuredProductsCarousel.title}_${window.datalayerdata.pageCategory}`);
    }, []);
    return (React.createElement("section", { className: carouselClasses },
        videoBg && (React.createElement(React.Fragment, null,
            React.createElement(ThronVideo, { thronID: props.featuredProductsCarousel.thronID, thronMobileID: props.featuredProductsCarousel.thronMobileID, autoplay: true, muted: true, className: "controlled" }))),
        React.createElement("h2", { className: "product-carousel__title primary-l", id: props.featuredProductsCarousel.ID }, props.featuredProductsCarousel.title),
        props.featuredProductsCarousel.text && React.createElement("div", { className: "product-carousel__text" }, props.featuredProductsCarousel.text),
        React.createElement("div", { className: "product-carousel__carousel-container container has-gutter" },
            React.createElement(SwiperInstance, { speed: 1000, wrapperTag: "ul", slidesPerView: 1.1, breakpoints: {
                    1200: {
                        slidesPerView: 3,
                        slidesPerGroup: 1,
                    },
                    600: {
                        slidesPerView: 3,
                        slidesPerGroup: 1,
                    },
                }, spaceBetween: 0, initialSlide: 0, pagination: {
                    clickable: true,
                }, onInit: (swiper) => {
                    swiper.navigation.update();
                }, a11y: {
                    slideRole: '',
                    slideLabelMessage: '',
                } }, props.featuredProductsCarousel.regions.product_slides.components.map((el, index) => {
                var _a;
                return (React.createElement(SwiperSlide, { key: index, tag: "li" },
                    React.createElement(ProductTileFeatured, { product: el.product, imgEditorial: (_a = el.img_desktop) === null || _a === void 0 ? void 0 : _a.path, index: index, description: el.description, simplified: props.featuredProductsCarousel.simplified, videoBg: !!videoBg, actionList: `featured products_${props.featuredProductsCarousel.title}_${window.datalayerdata.pageCategory}` })));
            })))));
};
export default FeaturedProducts;
